import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { OutlinedInput } from '@material-ui/core';

import AdditionalServiceWrapperContainer from '../additionalServiceWrapper/AdditionalServiceWrapperContainer';
import AdditionalServicesPaymentsBreakdown from '../additionalServicesPaymentsBreakdown/additionalServicesPaymentsBreakdown';

import Awb from '../../../../models/Awb';
import CartItem from '../../../../models/CartItem';
import AddServicesAllowed from '../../../../models/AddServicesAllowed';
import { AddServiceRawType } from '../../../../utils/additionalServices';

import additionalServicesStyles from './additionalServicesModal.module.css';
import commonStyles from '../../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    dialog: {
      padding: '24px 24px 8px'
    }
  });

interface AdditionalServicesModalProps {
  classes: any;
  awb: Awb;
  modalOpen: boolean;
  handleClose: () => void;
  handleChange: (event: any) => void;
  additionalServiceNames: Array<[string, AddServiceRawType]>;
  serviceRawName: string;
  serviceDescription: string;
  serviceDetails: any;
  total: number;
  getFeeRequest: Function;
  cartItem: CartItem | undefined;
  deleteService: Function;
  isDeletedService: boolean;
  changeIsDeleteStatus: Function;
  isExport?: boolean;
};

const additionalServicesModal = (props: AdditionalServicesModalProps) => {

  let allowedServices: AddServicesAllowed;
  let allowedService: boolean = false;
  let isServiceInCart: boolean = false;

  if (props.cartItem) {
    allowedServices = props.cartItem.allowedServices || {} as AddServicesAllowed;
    allowedServices.storage_fee = true;
    allowedService = allowedServices[props.serviceRawName as AddServiceRawType];
    isServiceInCart = (props.cartItem.services.filter((service: any) => service.type === props.serviceRawName)).length > 0;
  };
  
  const { classes, awb } = props;
  const additionalServices = props.additionalServiceNames.map((serviceArray: [string, AddServiceRawType], index: number) => (
      <option key={ index } value={ serviceArray[1] } >{ serviceArray[0] }</option>
    ));
  
  return (
    <Dialog
      open={ props.modalOpen }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'md' }
    >
      <div className={ additionalServicesStyles.dialogWrapper }>
        <DialogTitle className={ classes.dialog }>
          <div className={ additionalServicesStyles.titleWrapper }>
            <div className={ additionalServicesStyles.titleWrapperTitleContainer }>
              <h1 className={ additionalServicesStyles.titleWrapperTitle }>Additional services </h1>
              <IconButton aria-label="Close" className={ classes.close } onClick={ props.handleClose }>
              <CloseIcon color='primary' />
            </IconButton>
            </div>
            <div className={ additionalServicesStyles.titleModal }>
              <span className={ additionalServicesStyles.titleModalAwbno }>for AWB: { awb.code }-{ awb.number }</span>
              <div className={ additionalServicesStyles.titleModalAwbDetails }>
                <span>{ awb.pieces }</span>
                <span>{ awb.weight }</span>
                <span>{ awb.origin }-{ awb.destination }</span>
              </div>
            </div>
          </div>
        </DialogTitle>
        <hr/>

        <DialogContent>
          <FormControl>
            <label className={ commonStyles.inputLabel }> Additional Service <span className={ additionalServicesStyles.asterisk }>*</span></label>
            <Select native onChange={ props.handleChange }
              placeholder="-- Select Additional Service --"
             >
              <option value="" />
              { additionalServices }
            </Select>
          </FormControl>

          { (props.serviceDescription || props.serviceRawName === 'certified_manifest_charge') &&
            <Fragment>
              <div className={ `${ commonStyles.wrapper } ${ commonStyles.mt3 }` }>
                <div className={ additionalServicesStyles.descriptionTitleWrapper }>
                  <h3 className={ `${ commonStyles.header } ${ commonStyles.mt0 }`}>Description:</h3>
                </div>
                <div className={ additionalServicesStyles.descriptionTextWrapper }>{ props.serviceDescription || 'Certified Manifest Charge' }</div>

              { props.cartItem  &&
                <AdditionalServiceWrapperContainer
                  serviceRawName={ props.serviceRawName }
                  serviceDetails={ props.serviceDetails }
                  total={ props.total }
                  getFeeRequest={ props.getFeeRequest }
                  cartItem={ props.cartItem }
                  isDeletedService={ props.isDeletedService }
                  changeIsDeleteStatus={ props.changeIsDeleteStatus }
                  allowedService={ allowedService }
                  isServiceInCart={ isServiceInCart }
                  isExport={ props.isExport }
                />
              }
              </div>
            </Fragment>
          }
          { props.cartItem &&
            <AdditionalServicesPaymentsBreakdown
              additionalServices={ props.cartItem.services }
              remainDue={ props.cartItem.remainDue }
              totalPaid={ props.cartItem.totalPaid }
              totalPending={ props.cartItem.totalPending }
              deleteService={ props.deleteService }
            />
          }

        </DialogContent>
      </div>
    </Dialog>
  );
}

export default withStyles(styles)(additionalServicesModal);